// extracted by mini-css-extract-plugin
module.exports = {"snackbar":"snackbar_snackbar__1u49Q","fadeIn":"snackbar_fadeIn__3KXzF","fadeOut":"snackbar_fadeOut__TDNO8"};